import { parsePhoneNumber } from 'libphonenumber-js';

/** Normalize to E.164 for Twilio / sms-builder when valid US number. */
export function formatPhoneToE164US(phone: string | undefined | null): string | null {
  if (!phone || typeof phone !== 'string') return null;
  const t = phone.trim();
  if (!t) return null;
  try {
    const n = parsePhoneNumber(t, 'US');
    if (!n?.isValid()) return null;
    return n.format('E.164');
  } catch {
    return null;
  }
}
